import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "../../utils/axiosConfig";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";

const FinalCTASection = ({
  t,
  language,
  phoneValue,
  setPhoneValue,
  countrySelectOptions,
  selectedCountry,
  setSelectedCountry,
  formatCountryOption,
}) => {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetForm = () => {
    setName("");
    setCompany("");
    setEmail("");
    setMessage("");
    setPhoneValue("");
    setSelectedCountry(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    const emailValue = email.trim();
    const nameValue = name.trim();
    const companyValue = company.trim();
    const messageValue = message.trim();
    const countryLabel = selectedCountry?.label || "";
    const missingFields =
      !nameValue ||
      !companyValue ||
      !selectedCountry ||
      !emailValue ||
      !messageValue;
    if (missingFields) {
      Swal.fire(
        language === "es" ? "Faltan campos" : "Missing fields",
        language === "es"
          ? "Completa nombre, empresa, país, correo y mensaje."
          : "Please fill name, company, country, email, and message.",
        "warning"
      );
      return;
    }
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    if (!emailOk) {
      Swal.fire(
        language === "es" ? "Correo inválido" : "Invalid email",
        language === "es"
          ? "Verifica el correo e intenta de nuevo."
          : "Please check the email and try again.",
        "error"
      );
      return;
    }

    try {
      setIsSubmitting(true);
      Swal.fire({
        title: language === "es" ? "Enviando..." : "Sending...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}/operaciones2/setleadcomercial`,
        {
          Nombre: nameValue,
          Empresa: companyValue,
          Telefono: phoneValue,
          Pais: countryLabel,
          Correo: emailValue,
          Mensaje: messageValue,
        }
      );
      console.log("Lead comercial enviado:", response.data);
      if (response.data?.success !== true) {
        throw new Error(
          response.data?.message ||
          "Error desconocido al enviar el formulario."
        );
      }
      Swal.close();
      resetForm();
      Swal.fire(
        language === "es" ? "Enviado" : "Sent",
        language === "es"
          ? "Gracias. Te contactaremos pronto."
          : "Thanks. We will contact you soon.",
        "success"
      );
    } catch (error) {
      Swal.close();
      const errorMessage =
        error?.response?.data?.message ||
        (language === "es"
          ? "No se pudo enviar el formulario. Intenta de nuevo."
          : "We could not send the form. Please try again.");
      console.error("Error enviando lead comercial:", error);
      Swal.fire(
        language === "es" ? "Error" : "Error",
        errorMessage,
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="final-cta anim-section home-section" id="contacto">
      <div className="home-container final-grid">
        <div className="final-copy">
          <p className="eyebrow">
            {language === "es"
              ? "Agenda una demo y te montamos un piloto"
              : "Book a demo and we set up a pilot"}
          </p>
          <h2>{t.final.head}</h2>
          <p>{t.final.sub}</p>
          <div className="final-list">
            {t.final.list.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
        <form className="final-form" onSubmit={handleSubmit}>
          <label>
            {t.final.form.nombre}
            <input
              type="text"
              placeholder={t.final.form.nombrePlaceholder}
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </label>
          <label>
            {t.final.form.empresa}
            <input
              type="text"
              placeholder={t.final.form.empresaPlaceholder}
              value={company}
              onChange={(event) => setCompany(event.target.value)}
            />
          </label>
          <label>
            {t.final.form.correo}
            <input
              type="email"
              placeholder={t.final.form.correoPlaceholder}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <label>
            {t.final.form.telefono}
            <PhoneInput
              country="co"
              value={phoneValue}
              onChange={setPhoneValue}
              placeholder={t.final.form.telefonoPlaceholder}
              inputClass="phone-input"
              buttonClass="phone-flag"
              containerClass="phone-container"
              dropdownClass="phone-dropdown"
            />
          </label>
          <label>
            {t.final.form.pais}
            <Select
              classNamePrefix="country-select"
              className="country-select"
              placeholder={t.final.form.paisPlaceholder}
              options={countrySelectOptions}
              value={selectedCountry}
              onChange={setSelectedCountry}
              formatOptionLabel={formatCountryOption}
              isSearchable
            />
          </label>
          <label>
            {t.final.form.mensaje}
            <textarea
              className="message-input"
              placeholder={t.final.form.mensajePlaceholder}
              rows={4}
              maxLength={500}
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
            <span className="message-counter">
              {`${message.length}/500`}
            </span>
          </label>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            {t.buttons.solicitarDemo}
          </button>
        </form>
      </div>
    </section>
  );
};

export default FinalCTASection;
